













































import Vue from 'vue'
import { getAgencies } from '~/api/Agency/agency.api'
import { carPriceConfigController } from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import TableSwitch from '~/components/TableSwitch.vue'
import { Params, TableHeader } from '~/utils/interfaces'
import {
  CarPriceConfig,
  CreateCarPriceConfig,
} from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { AppView, Autocomplete, TableSwitch },
  data() {
    return {
      controller: carPriceConfigController,
      headers: [
        {
          text: this.$t('agency_name'),
          value: 'agency_name',
        },
        {
          text: this.$t('min_amount'),
          value: 'min_amount',
        },
        {
          text: this.$t('max_amount'),
          value: 'max_amount',
        },
        {
          text: this.$t('percent'),
          value: 'percent',
        },
        {
          text: this.$t('can_create_rental_contract'),
          value: 'can_create_rental_contract',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarPriceConfig>[],
      defaultCrud: {
        agency: '',
        min_amount: '',
        max_amount: '',
        percent: '',
        can_create_rental_contract: true,
      } as CreateCarPriceConfig,
    }
  },
  methods: {
    getAgencies: (params?: Params) =>
      getAgencies({ ...params, not_self: true }),
  },
})
